import { render, staticRenderFns } from "./CardBilling.vue?vue&type=template&id=564571f6&scoped=true&"
import script from "./CardBilling.vue?vue&type=script&lang=js&"
export * from "./CardBilling.vue?vue&type=script&lang=js&"
import style0 from "./CardBilling.vue?vue&type=style&index=0&id=564571f6&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "564571f6",
  null
  
)

export default component.exports